module.exports = __webpack_public_path__ + "static/media/insufficient-funds.3f6a8674.png";